import { render, staticRenderFns } from "./image-lightbox.vue?vue&type=template&id=a43b4c00&scoped=true&"
import script from "./image-lightbox.vue?vue&type=script&lang=js&"
export * from "./image-lightbox.vue?vue&type=script&lang=js&"
import style0 from "./image-lightbox.vue?vue&type=style&index=0&id=a43b4c00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a43b4c00",
  null
  
)

export default component.exports